import { render, staticRenderFns } from "./oldAddJob.vue?vue&type=template&id=6af6586d&"
import script from "./oldAddJob.vue?vue&type=script&lang=ts&"
export * from "./oldAddJob.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports